import { Table } from "antd";
import { useTranslation } from "react-i18next";
import "./liquidity-gap-table.scss";
import TableNumber from "../../../../../atoms/table-number";

const LiquidityGapTable = () => {
    const { t } = useTranslation();

    const assetsData = [
        {
            key: '1',
            assets: 'Assets:',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-11m': '',
            '1y': '',
            '2y': '',
            '>2y': '',
            'grandTotal': '',
        },
        {
            key: '2',
            assets: 'Due From Banks & Loans To Banks',
            '1m': '10,775',
            '2m': '131',
            '3m': '509',
            '4m': '369',
            '5m': '659',
            '6m': '145',
            '7-11m': '1,495',
            '1y': '76',
            '2y': '0',
            '>2y': '0',
            'grandTotal': '14,159',
        },
        {
            key: '3',
            assets: 'International Investment',
            '1m': '141',
            '2m': '52',
            '3m': '39',
            '4m': '72',
            '5m': '20',
            '6m': '155',
            '7-11m': '746',
            '1y': '244',
            '2y': '1,102',
            '>2y': '7,034',
            'grandTotal': '9,606',
        },
        {
            key: '4',
            assets: 'Loans & Advances',
            '1m': '38,724',
            '2m': '5,704',
            '3m': '6,068',
            '4m': '3,274',
            '5m': '2,517',
            '6m': '4,592',
            '7-11m': '11,525',
            '1y': '4,461',
            '2y': '16,871',
            '>2y': '54,555',
            'grandTotal': '148,290',
        },

        {
            key: '5',
            assets: 'Other Assets',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-11m': '',
            '1y': '',
            '2y': '',
            '>2y': '',
            'grandTotal': '-',
        },

        {
            key: '6',
            assets: 'Total Assets',
            '1m': '49,639',
            '2m': '5,887',
            '3m': '6,615',
            '4m': '3,716',
            '5m': '3,196',
            '6m': '4,893',
            '7-11m': '13,766',
            '1y': '4,781',
            '2y': '17,973',
            '>2y': '61,589',
            'grandTotal': '172,055',
        },
    ];

    const liabilitiesData = [
        {
            key: '1',
            assets: 'Liabilities:',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-11m': '',
            '1y': '',
            '2y': '',
            '>2y': '',
            'grandTotal': '',
        },
        {
            key: '2',
            assets: 'Due To Banks',
            '1m': '(2,096)',
            '2m': '(377)',
            '3m': '(1,081)',
            '4m': '(190)',
            '5m': '(808)',
            '6m': '(303)',
            '7-11m': '(2)',
            '1y': '0',
            '2y': '(0)',
            '>2y': '0',
            'grandTotal': '(4,857)',
        },
        {
            key: '3',
            assets: 'Customer Deposits',
            '1m': '(40,915)',
            '2m': '(11,573)',
            '3m': '(5,931)',
            '4m': '(5,016)',
            '5m': '(1,793)',
            '6m': '(4,154)',
            '7-11m': '(12,739)',
            '1y': '(3,193)',
            '2y': '(5)',
            '>2y': '(769)',
            'grandTotal': '(86,087)',
        },
        {
            key: '4',
            assets: 'Customer Deposits',
            '1m': '0',
            '2m': '(24,393)',
            '3m': '0',
            '4m': '0',
            '5m': '0',
            '6m': '0',
            '7-11m': '0',
            '1y': '0',
            '2y': '0',
            '>2y': '(40,961)',
            'grandTotal': '(65,354)',
        },

        {
            key: '5',
            assets: 'Debt Security',
            '1m': '0',
            '2m': '-16',
            '3m': '0',
            '4m': '0',
            '5m': '-18',
            '6m': '0',
            '7-11m': '-36',
            '1y': '0',
            '2y': '0',
            '>2y': '-4795',
            'grandTotal': '-4864',
        },

        {
            key: '6',
            assets: 'Other Liabilities',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-11m': '',
            '1y': '',
            '2y': '',
            '>2y': '',
            'grandTotal': '0',
        },

        {
            key: '7',
            assets: 'Total Liabilities',
            '1m': '(43,011)',
            '2m': '(36,359)',
            '3m': '(7,012)',
            '4m': '(5,206)',
            '5m': '(2,619)',
            '6m': '(4,456)',
            '7-11m': '(12,778)',
            '1y': '(3,193)',
            '2y': '(5)',
            '>2y': '(46,525)',
            'grandTotal': '(161,163)',
        },
        {
            key: '8',
            assets: 'Total Equity',
            '1m': '',
            '2m': '',
            '3m': '',
            '4m': '',
            '5m': '',
            '6m': '',
            '7-11m': '',
            '1y': '',
            '2y': '',
            '>2y': '',
            'grandTotal': '',
        },
        {
            key: '9',
            assets: 'Total Liabilities & Equity',
            '1m': '(43,011)',
            '2m': '(36,359)',
            '3m': '(7,012)',
            '4m': '(5,206)',
            '5m': '(2,619)',
            '6m': '(4,456)',
            '7-11m': '(12,778)',
            '1y': '(3,193)',
            '2y': '(5)',
            '>2y': '(46,525)',
            'grandTotal': '(161,163)',
        },
    ];


    const periodCumulativeData = [
        {
            key: '1',
            assets: 'Period Gap',
            '1m': '6,628',
            '2m': '(30,472)',
            '3m': '(396)',
            '4m': '(1,489)',
            '5m': '577',
            '6m': '436',
            '7-11m': '988',
            '1y': '1,588',
            '2y': '17,968',
            '>2y': '15,064',
            'grandTotal': '10,891',
        },
        {
            key: '2',
            assets: 'Cumulative Gap',
            '1m': '6,628',
            '2m': '(23,844)',
            '3m': '(24,241)',
            '4m': '(25,730)',
            '5m': '(25,153)',
            '6m': '(24,717)',
            '7-11m': '(23,728)',
            '1y': '(22,140)',
            '2y': '(4,172)',
            '>2y': '10,891',
            'grandTotal': '',
        },
    ];

    const columns = [
        {
            title: '',
            dataIndex: 'assets',
            key: 'assets',
            width: 220,
            fixed: 'left' as const,
            render: (text: string) => text === 'Assets:' || text === 'Liabilities:' ? <b>{text}</b> : text
        },
        {
            title: '1m',
            dataIndex: '1m',
            key: '1m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '2m',
            dataIndex: '2m',
            key: '2m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },

        {
            title: '3m',
            dataIndex: '3m',
            key: '3m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '4m',
            dataIndex: '4m',
            key: '4m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '5m',
            dataIndex: '5m',
            key: '5m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '6m',
            dataIndex: '6m',
            key: '6m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '7 - 11m',
            dataIndex: '7-11m',
            key: '7-11m',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '1y',
            dataIndex: '1y',
            key: '1y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '2y',
            dataIndex: '2y',
            key: '2y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
        {
            title: '>2y',
            dataIndex: '>2y',
            key: '>2y',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },

        {
            title: 'Grand Total',
            dataIndex: 'grandTotal',
            key: 'grandTotal',
            align: 'center' as const,
            render: (text: string)=> <TableNumber value={text} />
        },
    ];

    return (
        <div className="liquidity-gap-wrapper">
            <div className="liquidity-table">
                <div className="liquidity-table__heading">{t("AssetLiability.liquidityGapReport")}</div>
                <div className="liquidity-table__date">05/31/2024 · CAD {t("AssetLiability.inMillions")}</div>
                <div className="liquidity-table__table" >
                    <Table
                        scroll={{ x: 1360 }}
                        rowClassName={(record, index) => index % 2 === 0 ? 'liquidity-table__table__white' : 'liquidity-table__light-blue'}
                        dataSource={assetsData}
                        columns={columns}
                        pagination={false}
                    />
                </div>


                <div className="liquidity-table__table liabilities" >
                    <Table
                        scroll={{ x: 1360 }}
                        rowClassName={(record, index) => index % 2 === 0 ? 'liquidity-table__table__white' : 'liquidity-table__light-blue'}
                        dataSource={liabilitiesData}
                        columns={columns}
                        pagination={false}
                    />
                </div>

                <div className="liquidity-table__table periodCumulative" >
                    <Table
                        scroll={{ x: 1360 }}
                        rowClassName='liquidity-table__orange'
                        dataSource={periodCumulativeData}
                        columns={columns}
                        pagination={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default LiquidityGapTable;
